import { useContext } from 'react';
import { CompanyFormContext } from '../context/CompanyFormContext.jsx';

export const useCompanyForm = () => {
    const context = useContext(CompanyFormContext);
    if (!context) {
        throw new Error(
            'useCompanyForm must be used within a CompanyFormProvider',
        );
    }
    return context;
};
